import { render, staticRenderFns } from "./ProuniResidence.vue?vue&type=template&id=69aedca4&"
import script from "./ProuniResidence.vue?vue&type=script&lang=ts&"
export * from "./ProuniResidence.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports